var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.72C0 .77.794 0 1.774 0h20.452C23.206 0 24 .77 24 1.72V22.28c0 .95-.794 1.719-1.774 1.719H1.774C.794 24 0 23.23 0 22.281V1.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.245 12.384 5 6h4.154l3.238 3.946 3.458-3.928h2.288l-4.64 5.276L19 18h-4.142l-3.505-4.267-3.743 4.255h-2.3l4.935-5.604Zm5.217 4.433L7.547 7.183H8.55l7.905 9.634h-.993Z",
    fill: "var(--bg-color)"
  })));
};
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "ca53895e07c5f21473fb8936ce4c6db7.svg";